import React from "react";
import PropTypes from "prop-types";

export default function EditIcon({
    width = 13,
    height = 13,
    className = "",
    ...props
}) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`edit-icon ${className}`}
            {...props}
        >
            <path d="M0.0507812 10.0912V12.1598C0.0507812 12.3503 0.200483 12.5 0.391012 12.5H2.45961C2.54807 12.5 2.63653 12.466 2.69777 12.3979L10.1284 4.9741L7.57668 2.42237L0.15285 9.8462C0.0848044 9.91425 0.0507812 9.9959 0.0507812 10.0912ZM12.1017 3.00076C12.3671 2.73538 12.3671 2.30669 12.1017 2.04131L10.5095 0.449035C10.2441 0.183655 9.8154 0.183655 9.55002 0.449035L8.30477 1.69428L10.8565 4.24601L12.1017 3.00076Z" fill="#E75330" />
        </svg>
    );
}

EditIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
};